import styled from 'styled-components';
import { Box } from "../..";
export var SectionSpacer = styled(Box)(function (_ref) {
  var _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 3 : _ref$spacing,
    theme = _ref.theme;
  return {
    '& > *:not(:first-child)': {
      marginTop: "".concat((theme === null || theme === void 0 ? void 0 : theme.spacing(spacing)) || 8, "px")
    }
  };
});